import React from "react";
import styled from "styled-components";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import Button from "../../components/controls/button";
import { GoogleIcon, ICON_ID } from "../icons/google-icon";
import {
  toggleDeliveryMode,
  resetChanges,
} from "../../store/features/ordering/order-slice";
import { updateOrderline } from "../../store/features/ordering/order-slice";
import { ApplicationOrderLineUpdate } from "../../models/order/application-order-line-update";
interface DeliveryModeButtonProps {
  orderId: number;
  edit: boolean;
}
const DeliveryModeButton: React.FC<DeliveryModeButtonProps> = ({
  orderId,
  edit,
}) => {
  const dispatch = useAppDispatch();
  const orderLines = useAppSelector((state) => state.order).orderLines;

  const handleToggleDeliveryMode = () => {
    dispatch(toggleDeliveryMode());
  };

  const handleCancel = () => {
    dispatch(resetChanges());
  };

  const handleSaveChanges = (completeOrder: boolean) => {
    const orders: ApplicationOrderLineUpdate[] =
      orderLines?.orderLines.flatMap((line) => [
        {
          productId: line.productId,
          supplierId: line.supplierId,
          quantityReceived: Number(line.quantityReceived) || 0,
          deliveryNotes: line.deliveryNotes || "",
        },
        ...(line.children?.map((split) => ({
          productId: line.productId,
          supplierId: split.supplierId,
          quantityReceived: Number(split.quantityReceived) || 0,
          deliveryNotes: split.deliveryNotes || "",
        })) ?? []),
      ]) ?? [];

    dispatch(updateOrderline({ orderId, orders, completeOrder }));
  };

  return (
    <DeliveryModeContainer>
      {!edit ? (
        <Button
          variant="contained"
          id="btnDeliveryMode"
          label="Start Delivery"
          icon={ICON_ID.Edit}
          onClick={handleToggleDeliveryMode}
        />
      ) : (
        <>
          <ModeTag>
            <GoogleIcon id={ICON_ID.CheckCircle} isSecondary />
            Delivery mode active
          </ModeTag>
          <ButtonGroup>
          <Button
            variant="contained"
            isPrimary={false}
            isSecondary={true}
            id="btnCompleteChange"
            label="Complete"
            icon={ICON_ID.CheckCircle}
            onClick={() => handleSaveChanges(true)}
          />
          <Button
            variant="outlined"
            id="btnSaveChanges"
            label="Save as Draft"
            icon={ICON_ID.Save}
            onClick={() => handleSaveChanges(false)}
          />
          <Button
            variant="outlined"
            id="btnCancel"
            label="Cancel"
            icon={ICON_ID.Close}
            onClick={handleCancel}
          />
          </ButtonGroup>
        </>
      )}
    </DeliveryModeContainer>
  );
};

export default DeliveryModeButton;

const DeliveryModeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const ModeTag = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.78rem;
  background: ${(props) => props.theme.application.table.highlight};
  border: 1px solid ${(props) => props.theme.application.border};
  color: ${(props) => props.theme.application.scheme.primary};
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;
